import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import Label from '../Label'
import Arrow from '../Arrow'
import './Panel.sass'
import ToggleOpen from '../../decorators/ToggleOpen'

/* eslint-disable */
class Panel extends React.Component {
  static propTypes = {
    bsStyle: PropTypes.string,
    header: PropTypes.string.isRequired,
    toggle: PropTypes.object,
    id: PropTypes.number,
    itemStateName: PropTypes.string,
    children: PropTypes.node
  }

  static defaultProps = {
    bsStyle: 'default',
    toggle: {},
    id: null,
    itemStateName: ''
  }

  constructor(){
    super()
    this.state = {
      open: false
    }
  }
  toggleOpen = () => {
    this.setState({open: !this.state.open})
  }

  render(){
    const {bsStyle, header, children, toggle, id, itemStateName} = this.props
    const {open} = this.state
    return (
      <div className={"panel-wrapper panel-color--" + bsStyle}>
        <div
          className={`panel__header ${toggle && open ? '' : 'panel__header--none-border-bottom'} ${toggle && 'panel__header--cursor-pointer'}`}
          onClick={this.toggleOpen}
        >
          <div className="panel__header-text">
            {id || id !== null?
              <Link to={`/queries/${id}`}>{header} №{id}</Link>
              :
              <p>{header}</p>
            }

          </div>
          <div className="panel__header-info">
            {itemStateName &&
              <Label bsStyle={bsStyle}>
                {itemStateName}
              </Label>
            }
            {toggle &&
              <Arrow direction={open ? 'top' : 'bottom'} />
            }
          </div>
        </div>
        {toggle &&
          <div className={`panel__body ${open ? '' : 'panel__body--none'}`}>
            {children}
          </div>
        }
      </div>
    )
  }
}

export default ToggleOpen(Panel)



// WEBPACK FOOTER //
// ./components/Panel/index.jsx